import DateRangePicker from '../DateRangePicker';

import { TaskDateRange } from './taskCards';

type Props = {
  value: TaskDateRange;
  onChange: (range: TaskDateRange) => void;
};

// The Tasks header's created range. Unlike insights the range is a filter rather than the
// page's subject, so it starts empty and either end can be cleared to leave that side open —
// an empty start with an end a week back is "older than a week".
export default function TasksDateRangePicker({ value, onChange }: Props) {
  return <DateRangePicker value={value} onChange={onChange} testIdPrefix='task-created' gtmIdPrefix='tasks' />;
}
